import { oktaClient as api } from '@modules/core/services';
import { AxiosResponse } from 'axios';
import { GroupApiResponse } from '../types/GroupApiResponse';

export const getGroups = async (): Promise<AxiosResponse<GroupApiResponse[]> | undefined> => {
  return await api.get<GroupApiResponse[]>('groups');
};
